import Vue from 'vue';
import VueRouter from 'vue-router';
import Landing from '../views/Landing.vue';
import userAuthenticate from "@/middleware/userAuthenticate";
import Sports from "@/views/Sports";
import Leagues from "../views/Leagues";
import Soccer from "../views/Soccer";
import Olympics from "../views/Olympics";
import Predictions from "../views/Predictions";
import MakeSoccerPredictions from "../views/soccer/MakeSoccerPredictions";
import ViewSoccerPredictions from "../views/soccer/ViewSoccerPredictions";
import MakeOlympicsPredictions from "../views/olympics/MakeOlympicsPredictions";
import ViewOlympicsPredictions from "../views/olympics/ViewOlympicsPredictions";
import MakeCricketPredictions from "../views/cricket/MakeCricketPredictions";
import ViewCricketPredictions from "../views/cricket/ViewCricketPredictions";
import YourWinings from "../views/YourWinings";
import Rounds from "@/views/Rounds";
import Leaderboard from "../views/Leaderboard";

Vue.use(VueRouter);

const routes = [
    {
        path: '*',
        redirect: '/',
        beforeEnter: async (to, from, next) => {
            await userAuthenticate(to, from, next);
            next();
        },
    },
    {
        path: '/',
        component: Landing,
        children: [
            {
                path: 'sports',
                component: Sports,
                name: Sports,
                beforeEnter: async (to, from, next) => {
                    await userAuthenticate(to, from, next);
                    next();
                }
            },
            {
                path: 'leagues',
                component: Leagues,
                name: Leagues,
                beforeEnter: async (to, from, next) => {
                    await userAuthenticate(to, from, next);
                    next();
                }
            },
            {
                path: 'rounds',
                component: Rounds,
                name: Rounds,
                beforeEnter: async (to, from, next) => {
                    await userAuthenticate(to, from, next);
                    next();
                }
            },
            {
                path: 'your-winnings',
                component: YourWinings,
                name: YourWinings,
                beforeEnter: async (to, from, next) => {
                    await userAuthenticate(to, from, next);
                    next();
                }
            },
            {
                path: 'leaderboard',
                component: Leaderboard,
                name: Leaderboard,
                beforeEnter: async (to, from, next) => {
                    await userAuthenticate(to, from, next);
                    next();
                }
            },
            {
                path: 'predictions',
                component: Predictions,
                name: Predictions,
                children: [
                    {
                        path: 'soccer',
                        component: Soccer,
                        name: Soccer,
                        children: [
                            {
                                path: 'make-predictions',
                                component: MakeSoccerPredictions,
                                name: MakeSoccerPredictions,
                                beforeEnter: async (to, from, next) => {
                                    await userAuthenticate(to, from, next);
                                    next();
                                }
                            },
                            {
                                path: 'view-predictions',
                                component: ViewSoccerPredictions,
                                name: ViewSoccerPredictions,
                                beforeEnter: async (to, from, next) => {
                                    await userAuthenticate(to, from, next);
                                    next();
                                }
                            },
                        ]
                    },
                    {
                        path: 'cricket',
                        component: Soccer,
                        name: Soccer,
                        children: [
                            {
                                path: 'make-predictions',
                                component: MakeCricketPredictions,
                                name: MakeCricketPredictions,
                                beforeEnter: async (to, from, next) => {
                                    await userAuthenticate(to, from, next);
                                    next();
                                }
                            },
                            {
                                path: 'view-predictions',
                                component: ViewCricketPredictions,
                                name: ViewCricketPredictions,
                                beforeEnter: async (to, from, next) => {
                                    await userAuthenticate(to, from, next);
                                    next();
                                }
                            },
                        ]
                    },
                    {
                        path: 'olympics',
                        component: Olympics,
                        name: Olympics,
                        children: [
                            {
                                path: 'make-predictions',
                                component: MakeOlympicsPredictions,
                                name: MakeOlympicsPredictions,
                                beforeEnter: async (to, from, next) => {
                                    await userAuthenticate(to, from, next);
                                    next();
                                }
                            },
                            {
                                path: 'view-predictions',
                                component: ViewOlympicsPredictions,
                                name: ViewOlympicsPredictions,
                                beforeEnter: async (to, from, next) => {
                                    await userAuthenticate(to, from, next);
                                    next();
                                }
                            },
                        ]
                    },
                ]
            },
        ],
    }
];

const router = new VueRouter({
    mode: 'history',
    hash: false,
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const utagData = {
        page_name: window.location.host,
        page_section: to.fullPath,
        page_category: '',
        page_subcategory: '',
        page_type: 'Article',
        page_title: document.title,
        page_url: window.location.href,
        page_referrer: document.referrer,
        customer_id: '',
        customer_username: '',
        customer_country: window.navigator.language.split('-').reverse()[0],
        site_region: window.navigator.language,
        article_id: '',
        article_name: '',
        video_id: '',
        video_name: '',
        video_player: '',
        user_platform: window.clientInformation.platform,
        // connection_type: window.clientInformation.connection.effectiveType,
        team_id: '',
        page_event: '',
        ad_requests: '',
        page_channel: '',
        page_platform: '',
        am_report_suite: '',
        page_section_lvl1: '',
        page_section_lvl2: '',
        page_section_lvl3: '',
        page_section_lvl4: '',
        page_section_lvl5: ''
    }

    console.log('utag_data: ', utagData);
    const a = 'https://tags.tiqcdn.com/utag/vodafone/za-nxtvl-main/prod/utag.js';
    const b = document;
    const c = 'script';
    const d = b.createElement(c);
    d.src = a;
    d.type = 'text/java' + c;
    d.async = true;
    const e = b.getElementsByTagName(c)[0];
    e.parentNode.insertBefore(d, e);
    window.utag_data = utagData;

    next();
})

export default router
